<template>
    <div class="lang-select" role="navigation" aria-label="Select language / Vælg sprog">
        <a :class="{ 'is-selected': !isDanish }"
           href="/english/"
           class="lang-select__anchor"
           lang="en"
           aria-label="English homepage"
           :aria-current="!isDanish ? 'true' : ''"
           :aria-hidden="disableFocus"
           :tabindex="tabIndex"
        >
            ENG
        </a>
        &nbsp;/&nbsp;
        <a :class="{ 'is-selected': isDanish }"
           href="/"
           class="lang-select__anchor"
           lang="da"
           aria-label="Dansk hjemmeside"
           :aria-current="isDanish ? 'true' : ''"
           :aria-hidden="disableFocus"
           :tabindex="tabIndex"
        >
            DK
        </a>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { isOnDanish } from '../../utils/is-on-language';

    export default Vue.extend({
        props: {
            disableFocus: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                isDanish: isOnDanish(),
                tabIndex: this.disableFocus ? '-1' : '0'
            };
        },
    });
</script>
